import React from 'react';
import {SearchClearIcon} from "./SearchClearIcon";

export const SearchClear: React.FC<React.HTMLAttributes<HTMLSpanElement>> = (props) => (
    <span className="search-clear" {...props}>
        <SearchClearIcon />
    </span>
);
